
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class CheckboxYesNo extends Vue {
  @Prop() value!: any
  @Prop() label!: any

  get selected() {
    return this.value
  }

  set selected(v) {
    this.$emit('input', v)
  }
}
